import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { SecurityService } from '../../services/security/security.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../security/security.service";
var VersionService = /** @class */ (function () {
    function VersionService(http, securityService) {
        this.http = http;
        this.securityService = securityService;
    }
    VersionService.prototype.get = function () {
        var _this = this;
        return this.http
            .get('./assets/version.json')
            .pipe(catchError(function (error) { return _this.securityService.catchResponse(error); }));
    };
    VersionService.ngInjectableDef = i0.defineInjectable({ factory: function VersionService_Factory() { return new VersionService(i0.inject(i1.HttpClient), i0.inject(i2.SecurityService)); }, token: VersionService, providedIn: "root" });
    return VersionService;
}());
export { VersionService };
